jQuery(document).ready(function ($) {
  $(window).on("load", function () {
    $(".section-fv").addClass("active");
  });
});
